import React from "react";
import FlipUnit from "./FlipUnit";

export default function AnimatedCountdown({ days, hours, minutes, seconds }) {
  return (
    <div style={{
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 8,
      marginTop: 12
    }}>
      
      {days > 0 && (
        <>
          <FlipUnit value={days} />
          <span style={{ fontSize: 20, fontWeight: 500, color: "#6A4AFF" }}>j</span>
        </>
      )}

      <FlipUnit value={hours} />
      
      <FlipUnit value={minutes} />
      
      <FlipUnit value={seconds} />

    </div>
  );
}
